import { api } from '@/shared/api/client';
import type { GetQuizzesResponse } from '../model/dto';

export const getQuizzes = async (contentId: string) => {
  const { data } = await api.get<GetQuizzesResponse>(
    `/contents/${contentId}/quizzes/`,
  );
  return data;
};
